module.exports = "# Theme Manager\nThis page is still in work.\n"


//////////////////
// WEBPACK FOOTER
// ./components/ThemeManager/THEME_MANAGER.md
// module id = 668
// module chunks = 0